var dayjs = require('dayjs');
var utc = require('dayjs/plugin/utc');
var relativeTime = require('dayjs/plugin/relativeTime');
var updateLocale = require('dayjs/plugin/updateLocale');

import { weekdaysShort as weekdays } from 'dayjs/locale/ja'

dayjs.extend(utc);
dayjs.extend(relativeTime);
dayjs.extend(updateLocale);
dayjs.locale('ja');

dayjs.updateLocale('en', {
  relativeTime: {
    future: "%s後",
    past: "%s前",
    s: '数秒',
    m: "1分",
    mm: "%d分",
    h: "1時間",
    hh: "%d時間",
    d: "1日",
    dd: "%d日",
    M: "1ヶ月",
    MM: "%dヶ月",
    y: "1年",
    yy: "%d年"
  }
});

export default dayjs;